import { Injectable } from '@angular/core'
import { distinctUntilChanged, map, shareReplay } from 'rxjs'
import { AppConfigService } from './app-config.service'
import { AuthService } from './auth.service'

@Injectable({ providedIn: 'root' })

export class ExportsService {

  list$ = this.appConfigService.state$.pipe(
    map(({ exports: { enableAllForSpecificUsers = [], exports = [] } = {} }) => {
      const user = this.authService.getUsername()

      return exports
        .filter(({ enableForSpecificUsers }) => enableAllForSpecificUsers.includes(user) || enableForSpecificUsers.includes(user))
        .map(({ name, href }) => ({ name, href }))
    }),
    distinctUntilChanged(),
    shareReplay(1)
  )

  constructor (
    private appConfigService: AppConfigService,
    private authService: AuthService
  ) {}
}
